import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { mdiAlert, mdiClose } from '@mdi/js';
import CollapsibleSnackBar from '../CollapsibleSnackBar/CollapsibleSnackBar';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { useMapScale } from 'client/pages/MapPage/hooks/useMapScale';
import { selectAOIMode } from 'client/store/mapSlice/mapSlice';
import { useState, useEffect } from 'react';

import Button from 'client/components/aria/Button/Button';
import styles from '../button.module.scss';
import Icon from '@mdi/react';

const AssetsHiddenSnackBar = () => {
    const intl = useIntl();
    const isAoiMode = useSelector(selectAOIMode);
    const scale = useMapScale();
    const assets = useSelector(state => state.assets);
    const leaves = useSelector(state => state.layers.result.hierarchy.leaves());
    const [dismissed, setDismissed] = useState(false);
    const [relevant, setRelevant] = useState(false);

    const layersOutsideScaleThreshold = leaves.filter(leaf => scale > leaf.data.maxScale || scale < leaf.data.minScale);
    const nonEmptyHiddenLayers = layersOutsideScaleThreshold.filter(layer => assets.layers[layer.data.assetType]?.length > 0);

    useEffect(() => {
        setRelevant(isAoiMode && nonEmptyHiddenLayers.length > 0);
        if (!isAoiMode) {
            // reset closed state after AOI is cleared
            // this allows the notification to be displayed again after they have closed it
            // when it is a new/edited AOI
            setDismissed(false);
        }
    }, [isAoiMode, nonEmptyHiddenLayers]);

    const closeButton = <Button
        data-testid="assetsHiddenSnackBar.closeAlert"
        variant="transparent"
        className={styles.button}
        aria-label={ intl.formatMessage({ id: 'general.closeNotification' }) }
        onPress={() => { setDismissed(true); }}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    return (relevant && !dismissed &&
        <SnackBar variant="warning" endOfLine={closeButton}>
            <CollapsibleSnackBar
                icon={mdiAlert}
                label={ intl.formatMessage({ id: 'assetsHidden.notification.label' })}
                data-testid="assetsHiddenSnackBar.alert"
            >
                <FormattedMessage id='assetsHidden.alert' />
            </CollapsibleSnackBar>
        </SnackBar>
    );
};

export default AssetsHiddenSnackBar;
